import React, { Component } from 'react';
import Loader from '../common/loader';
import {tuckCountReportService, truckDetailsService} from '../../services/reportService';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { toastr } from 'react-redux-toastr';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import $ from 'jquery';

class TruckCount extends Component {
    constructor(props){
        super(props);
        this.state={
            isReady:false,
            loadList:[],
            rowExpanded:false,
            truckList:[]
        }
    }

    componentDidMount = () => {
        document.title = 'Truck Count Report';
        this.loadInitial();
    }

    loadInitial = () => {
        tuckCountReportService().then((data) =>{
            console.log(data);
            let loadList = [];
            if(data){
                if(data.truckCountList){
                    loadList=data.truckCountList;
                }
            }
            this.setState({
                ...this.state,
                loadList:loadList,
                isReady:true
            });
        });
    }

    getRowData = () => {
        if(this.state.loadList.length===0){
            return [];
        } else {
            let loadList= this.state.loadList.map(
                (row,index) =>{
                    return {
                        id:index,
                        Company_Id:row.Company_Id,
                        Company_Name:row.Company_Name,
                        Truck_Count:row.Truck_Count,
                        emptyField:' ',
                        expandRow:<a href="/#" onClick={(e) =>{e.preventDefault()}} className="icofont-plus-circle expandIcon"/>
                    };
                }
            );
            return loadList;
        }
    }

    getTableColumns = () => {
        return [
            {
                text:' ',
                sort:false,
                dataField:'expandRow'
            },	
            {
                text:'Client',
                sort:true,
                dataField:'Company_Name'
            },
            {
                text:'Truck Count',
                sort:true,
                dataField:'Truck_Count',
                style:{width: '10%'},
                align:'right'
            },
            {
                text:' ',
                dataField:'emptyField',
                style:{width: '10%'}
            }
        ];
    }

    exportData = () => {        
        if(this.state.loadList.length===0){
            toastr.info('Info', 'No Data Available!');
            return;
        }
        let csvData = this.state.loadList.map(row =>{
            return {
                Client_Name:row.Company_Name,
                Truck_Count:row.Truck_Count
            }
        });
        let fileName = 'Truck Count';
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, fileName + fileExtension);
    }

    getTruckDetails = (row) => {
        console.log(row) ;
        this.setState({
            ...this.state,
            rowExpanded:false,
            truckList:[]
        })       
        let param = {
            payload:{                
                companyId:row.Company_Id
            }
        }
        truckDetailsService(param).then( (response) =>{
            let truckList = [];
            if(response && response.truckList){
                truckList=response.truckList;                
            } 
            this.setState({
                ...this.state,
                rowExpanded:true,
                truckList:truckList
            })
            
        } );
    }

    expandRow = () =>{
        //console.log('Hi');
        return {
             showExpandColumn: false,
             expandByColumnOnly: false,
             onlyOneExpanding:true,            
            renderer:(row, index) =>{                                
                if(this.state.rowExpanded){                    
                    return(this.getChildTable());
                } else {                    
                    return(<Loader />);
                }
            },
            onExpand: (row, isExpand, rowIndex, e) => {
                $("#truckCount a.icofont-minus-circle").removeClass('icofont-minus-circle').addClass('icofont-plus-circle');
                if(isExpand){
                    $(e.target).closest('tr').find('a.expandIcon').removeClass('icofont-plus-circle').addClass('icofont-minus-circle');
                    setTimeout(
                    () =>  this.getTruckDetails(row), 
                    100
                  );                                                    
                }               
            }
        };
    }

    getChildTable = () =>{
        const { SearchBar } = Search;

        const customTotal = (from, to, size) => (
            <span className="react-bootstrap-table-pagination-total">
              Showing { from } to { to } of { size } Results
            </span>
        );
          
        const options = {
            paginationSize: 4,
            pageStartIndex: 1,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: '<<<',
            prePageText: '<<',
            nextPageText: '>>',
            lastPageText: '>>>',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            paginationTotalRenderer: customTotal,
        };
        const defaultSorted = [{
            dataField: 'Asset_Number',
            order: 'asc'
        }];

        return(
        <ToolkitProvider        
                    keyField="id"
                    data={ this.getChildTableRows() }
                    columns={ this.getChildTableColumns() }
                    search
                    >
                    {
                        props => (
                            <div>                                
                                <SearchBar { ...props.searchProps } />
                            
                                <BootstrapTable
                                    { ...props.baseProps } pagination={ paginationFactory(options) } noDataIndication={'No data found'} hover 
                                    bordered={ false } defaultSorted={defaultSorted} 
                                />
                            </div>
                        )
                    }
                </ToolkitProvider>
        );
    }

    getChildTableColumns = () => {
        return [
            	
            {
                text:'Asset Number',
                dataField:'Asset_Number',
                sort:true
            },
            {
                text:'Licence Plate Number',
                dataField:'License_Plate_No',
                sort:true
            },
            {
                text:'VIN',
                dataField:'Identification_No',
                sort:true
            },
            {
                text:'ELD Provider Name',
                dataField:'ELD_Provider_Name',
                sort:true
            }
            
           ];
    }

    getChildTableRows = () => {
        return this.state.truckList.map((row,index) =>{            
            return({
                id:index,
                Asset_Number:row.Asset_Number,
                License_Plate_No:row.License_Plate_No,
                Identification_No:row.Identification_No,
                ELD_Provider_Name:row.ELD_Provider_Name
            })
        });
    }

    //{truck_count: 54, Company_Name: "FreightCo Dedicated, LLC."}
    render() {
        if(this.state.isReady){
            const { SearchBar } = Search;
            const customTotal = (from, to, size) => (
                <span className="react-bootstrap-table-pagination-total">
                  Showing { from } to { to } of { size } Results
                </span>
            );
              
            const options = {
                paginationSize: 4,
                pageStartIndex: 1,
                firstPageText: 'First',
                prePageText: 'Back',
                nextPageText: 'Next',
                lastPageText: 'Last',
                nextPageTitle: 'First page',
                prePageTitle: 'Pre page',
                firstPageTitle: 'Next page',
                lastPageTitle: 'Last page',
                showTotal: true,
                paginationTotalRenderer: customTotal,
            };
            const defaultSorted = [{
                dataField: 'Company_Name',
                order: 'asc'
            }];
            return(
                <article className="table-data truck-data shadow bg-white rounded" style={{display:'block'}}>
                    <h3>Truck Count</h3> <br></br>
                    <ToolkitProvider
                        keyField="id"
                        data={ this.getRowData() }
                        columns={ this.getTableColumns() }
                        search
                        >
                        {
                            props => (
                                <div>
                                    <div className="btn-export float-left d-inline-block pr-2 font-weight-bold">Count : {this.state.loadList.length}</div>
                                    <SearchBar { ...props.searchProps } />
                                    <div className="btn-export float-right d-inline-block pr-2"><button onClick={(e)=>{this.exportData()}} className='btn btn-primary' >Export</button></div> 
                                    <BootstrapTable
                                        { ...props.baseProps } pagination={ paginationFactory(options) } noDataIndication={'No data found'} hover 
                                        bordered={ false } defaultSorted={defaultSorted} expandRow={ this.expandRow()} id="truckCount"
                                    />
                                </div>
                            )
                        }
                    </ToolkitProvider>
                </article>
            );
        } else {
            return(<Loader />);
        }
    }
}

export default TruckCount;